import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import label from "../../labels/interviewProcess_en.json";
import clabel from "../../../common/labels/common_en.json";
import _ from "lodash/fp";
import Select from "react-select";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import {
//   getUserListing,
//   saveNewUserData,
// } from "../../../actions/accessRightsManagementActions";
import { getSupervisorlist } from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import {
  getUserRoles,
  getqualificationNamebytype,
  setUpdateInterviewCriteria,
  setUpdateRecommendationCriteria,
} from "../../../common/actions/commonActions";
import {
  getUserListing,
  saveNewUserData,
} from "../../../accessRightsManagement/actions/accessRightsManagementActions";
import { ConsoleSqlOutlined } from "@ant-design/icons";
const UpdateRecommendationCriteria = (props) => {
  const { register, errors, handleSubmit, formState, watch } = useForm({
    mode: "onChange",
  });

  const dispatch = useDispatch();
  let dobcheckedistrue = [
    { id: 1, name: "ascending" },
    { id: 2, name: "descending" },
  ];
  let {
    getqualificationtype,
    getqualificationName,
    getDesignation,
    getjobnature,
    getappointmentNature,
    getInterviewCriteriaData,
  } = useSelector((state) => state.common, shallowEqual);

  let {
    adminCategoriesList,
    adminSubCategoriesList,
    allUnapprovalCutOffList,
    unapprovalCutOffPageNoCounter,
    getinterviewCriterialist,
    getinterviewCriteriaCounter,
  } = useSelector((state) => state.interviewProcessReducer, shallowEqual);

  let {
    examList,
    advertisementList,
    postcriterialisting,
    objectiveStatusData,
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);
  useEffect(() => {
    dispatch(getUserListing());
  }, []);

  useEffect(() => {
    setPostCriteriaOptions(null);

    if (postcriterialisting && postcriterialisting?.length >= 0) {
      const optionValue = postcriterialisting?.map((element) => ({
        value: element.id,
        label: element.name,
      }));
      setPostCriteriaOptions(optionValue);
    }
  }, [postcriterialisting]);

  useEffect(() => {
    if (props.setUpdatedValue.length > 0) {
      setSelectedPostCriteria([]);
      props.setUpdatedValue.map((item) => {
        const data = {
          label: item.postCriteriaName,
          value: item.postCriteriaId,
        };
        setSelectedPostCriteria((arr) => [...arr, data]);
      });
    }
  }, [props.setUpdatedValue]);

  const [selectedPostCriteria, setSelectedPostCriteria] = useState("");
  let [postCriteriaOptions, setPostCriteriaOptions] = useState([]);
  const [editdob, setEditdob] = useState(false);
  const [editqualification, setEditQualification] = useState(false);
  const [editexperience, setEditExperience] = useState(false);
  const [editCategory, setEditCatgeory] = useState(false);
  const [id, setId] = useState("");
  const [data, setData] = useState([]);
  const [dobCheckbox, setDobCheckbox] = useState([]);
  const [selectedCheckboxOrder, setSelectedCheckboxOrder] = useState([]);
  const [indexrow, setIndexRow] = useState("");
  const [indexexperience,setIndexexperience]=useState("");
  const [indexqualification,setIndexQualification]=useState("");
  const [indexdob,setIndexdob]=useState("");
  useEffect(() => {
    setData(props.setUpdatedValue);
  }, [indexrow,id]);

  
  const editUser = (ele, type, id, index) => {
    setIndexRow(index);
    
    if (type === "dob") {
      setEditdob(true);
      setIndexdob(index)
    } else if (type === "qualification") {
      setEditQualification(true);
      setIndexQualification(index)
      setId(id);
    } else if (type === "experience") {
      setEditExperience(true);
      setIndexexperience(index);
      setId(id);
    } else if (type === "category") {
      setEditCatgeory(true);
      setId(id);
    }
  };

  const onhandleexperiencecheckbox = (postID, selectedValues, innd) => {
    let selected = selectedValues;
    let tempReqData = [...data]; // Assuming data is the array containing the experience data
    let experienceIndex = selectedCheckboxOrder.indexOf("experience");

    tempReqData.forEach((reqData, ind) => {
      if (reqData.postCriteriaId === postID) {
        if (!reqData.experience && selected === false) {
          // If experience is undefined and checkbox is unchecked, do nothing
          return;
        } else if (!reqData.experience && selected === true) {
          // If experience is undefined and checkbox is checked, add experience field
          let experience = {
            experience: {
              type: "experience",
              flgConsider: selected,
              priority: selectedCheckboxOrder.length + 1,
              data: [],
            },
          };
          tempReqData[ind] = { ...reqData, ...experience };
        } else if (reqData.experience && selected === false) {
          // If experience is defined and checkbox is unchecked, remove experience field
          delete tempReqData[ind].experience;
        }
      }
    });

    // Update the state with the modified data
    setData([...tempReqData]);
  };

  const onDesignation = (postID, selectedValue, index) => {
    const tempReqData = data.map((reqData) => {
      if (reqData.postCriteriaId === postID) {
        reqData.experience = reqData.experience || {
          type: "experience",
          flgConsider: true,
          priority: 1,
          data: [],
        };

        // Check if the experience data exists and the index is within bounds
        if (
          reqData.experience.data &&
          reqData.experience.data[index] &&
          index >= 0 &&
          index < reqData.experience.data.length
        ) {
          reqData.experience.data[index].designation = selectedValue;
        }
      }
      return reqData;
    });
    setData(tempReqData);
  };

  const onJobNature = (postID, selectedValue, index) => {
    const tempReqData = data.map((reqData) => {
      if (
        reqData.postCriteriaId === postID &&
        reqData.experience.data &&
        reqData.experience.data[index] &&
        index >= 0 &&
        index < reqData.experience.data.length
      ) {
        reqData.experience.data[index].jobNatureLookupId = selectedValue;
      }
      return reqData;
    });
    setData(tempReqData);
  };

  const onAppointmentNature = (postID, selectedValue, index) => {
    const tempReqData = data.map((reqData) => {
      if (
        reqData?.postCriteriaId === postID &&
        reqData.experience.data &&
        reqData.experience.data[index] &&
        index >= 0 &&
        index < reqData.experience.data.length
      ) {
        reqData.experience.data[index].typeEmploymentLookupId = selectedValue;
      }
      return reqData;
    });
    setData(tempReqData);
  };

  const onhandlequalificationcheckbox = (postID, selectedValues, innd) => {
    let selected = selectedValues;
    let tempReqData = [...data]; // Assuming data is the array containing the experience data
    let qualificationIndex = selectedCheckboxOrder.indexOf("qualification");

    tempReqData.forEach((reqData, ind) => {
      if (reqData.postCriteriaId === postID) {
        if (!reqData.qualification && selected === false) {
          // If experience is undefined and checkbox is unchecked, do nothing
          return;
        } else if (!reqData.qualification && selected === true) {
          // If experience is undefined and checkbox is checked, add experience field
          let qualification = {
            qualification: {
              type: "qualification",
              flgConsider: selected,
              priority: selectedCheckboxOrder.length + 1,
              data: [],
            },
          };
          tempReqData[ind] = { ...reqData, ...qualification };
        } else if (reqData.qualification && selected === false) {
          // If experience is defined and checkbox is unchecked, remove experience field
          delete tempReqData[ind].qualification;
        }
      }
    });

    // Update the state with the modified data
    setData([...tempReqData]);
  };

  const onQualificationType = (postID, selectedValues, innd) => {
    let selected = selectedValues;
    getqualificationName.length = 0;
    let tempReqData = [...data];
    tempReqData.forEach((reqData, ind) => {
      if (reqData.postCriteriaId === postID) {
        reqData.qualification = reqData.qualification || {
          type: "experience",
          flgConsider: true,
          priority: 1,
          data: [],
        };

        // Update qualification type at the specified index
        if (reqData.qualification.data[innd]) {
          reqData.qualification.data[innd].qualificationtypecode =
            selectedValues;
        } else {
          // If the index is out of bounds, push a new entry
          reqData.qualification.data.push({
            priority: reqData.qualification.data.length + 1,
            qualificationtypecode: selectedValues,
            qualificationnamecode: "",
          });
        }
      }
    });
    setData(tempReqData);
    selected && dispatch(getqualificationNamebytype(selected));
  };

  const onQualificationName = (postID, selectedValues, innd) => {
    let tempReqData = [...data];
    tempReqData.forEach((reqData, ind) => {
      if (reqData.postCriteriaId === postID) {
        if (
          reqData.qualification &&
          reqData.qualification.data.length > 0 &&
          reqData.qualification.data[innd]
        ) {
          // Update qualification name at the specified index
          reqData.qualification.data[innd].qualificationnamecode =
            selectedValues;
        }
      }
    });
    setData(tempReqData);
  };

  const onhandledobcheckbox = (postID, selectedValues, innd) => {
    let selected = selectedValues;
    let dobLen = dobCheckbox.length;
    let tempReqData = [...data];
    let priority = selectedCheckboxOrder.length + 1;
    if (dobLen < innd) {
      let temp = [];
      for (let i = 0; i <= innd; i++) {
        if (i === innd) {
          temp.push(selected);
        } else {
          temp.push(dobCheckbox[i]);
        }
      }
      setDobCheckbox(temp);
    } else {
      let temp = dobCheckbox;
      temp[innd] = selected;
      setDobCheckbox(temp);
    } tempReqData.forEach((reqData, ind) => {
      if (reqData.postCriteriaId === postID) {
        const dobIndex = selectedCheckboxOrder.indexOf("dob");
        if (!reqData.dob && selected === false) {
          return;
        } else if (!reqData.dob && selected === true) {
     
          let dob = {
            dob: {
              type: "dob",
              flgConsider: selected,
              priority: priority++,
              order: "",
            },
          };
          const mergedObject = { ...reqData, ...dob };
          tempReqData[ind] = mergedObject;
          setSelectedCheckboxOrder((prevOrder) => [...prevOrder, "dob"]);
        } else if (reqData.dob && selected === false) {
          
          delete tempReqData[ind].dob;
          setSelectedCheckboxOrder((prevOrder) =>
            prevOrder.filter((type) => type !== "dob")
          );
        } else if (reqData.dob && selected === true) {
      
          tempReqData[ind].dob.flgConsider = selected;
          if (dobIndex === -1) {
            tempReqData.forEach((item, index) => {
              if (selectedCheckboxOrder.includes("dob") && item.dob) {
                item.dob.priority = index + 1;
              }
            });
          } else {
            tempReqData[ind].dob.priority = dobIndex + 1;
          }
          setSelectedCheckboxOrder((prevOrder) => [...prevOrder, "dob"]);
        }
      }
    });
    setData(tempReqData);
  };

  const ondobOrder = (postID, selectedValues, innd) => {
    let selected = selectedValues;
    let tempReqData = [...data]; // Ensure correct initialization

    tempReqData.forEach((reqData, ind) => {
      if (reqData.postCriteriaId === postID) {
        if (reqData.dob) {
          // Update existing DOB field
          tempReqData[ind].dob.order = selected;
        }
      }
    });

    setData(tempReqData);
  };

  const onCategoryChange = (postID, val, innd) => {
    const tempReqData = data.map((reqData) => {
      if (reqData.postCriteriaId === postID) {
        reqData.criteria = reqData.criteria || [];

        // Check if the criteria data exists and the index is within bounds
        if (
          reqData.criteria[innd] &&
          innd >= 0 &&
          innd < reqData.criteria.length
        ) {
          reqData.criteria[innd].category = val;
        } else {
          // If the criteria data doesn't exist, create a new one
          reqData.criteria[innd] = {
            category: val,
            subCategory: "",
            reservedSeats: "",
          };
        }
      }
      return reqData;
    });
    setData(tempReqData);
  };

  const onSubCategoryChange = (postID, selectedValues, innd) => {
    const tempReqData = data.map((reqData) => {
      if (reqData.postCriteriaId === postID) {
        reqData.criteria = reqData.criteria || [];

        // Check if the criteria data exists and the index is within bounds
        if (
          reqData.criteria[innd] &&
          innd >= 0 &&
          innd < reqData.criteria.length
        ) {
          // Assuming selectedValues is an array of selected sub-categories
          reqData.criteria[innd].subCategory = selectedValues;
        } else {
          // If the criteria data doesn't exist, create a new one
          reqData.criteria[innd] = {
            category: "",
            subCategory: selectedValues,
            reservedSeats: "",
          };
        }
      }
      return reqData;
    });
    setData(tempReqData);
  };

  const onReserveSeatChange = (postID, val, innd) => {
    const tempReqData = data.map((reqData) => {
      if (reqData.postCriteriaId === postID) {
        reqData.criteria = reqData.criteria || [];

        // Check if the criteria data exists and the index is within bounds
        if (
          reqData.criteria[innd] &&
          innd >= 0 &&
          innd < reqData.criteria.length
        ) {
          // Assuming selectedValues is an array of selected sub-categories
          reqData.criteria[innd].reservedSeats = val;
        } else {
          // If the criteria data doesn't exist, create a new one
          reqData.criteria[innd] = {
            category: "",
            subCategory: "",
            reservedSeats: val,
          };
        }
      }
      return reqData;
    });
    setData(tempReqData);
  };


  const onSubmit=()=>{
    dispatch(setUpdateRecommendationCriteria(data,props.selectedExam));
    props.setShowUpdateModal(false);
  }

  const handlePostCriteria = (selectedOptions) => {
    setSelectedPostCriteria(selectedOptions);
    const selectedIds = selectedOptions.map((option) => option.value);
    const updatedData = data.filter((item) =>
      selectedIds.includes(item.postCriteriaId)
    );
    setData(updatedData);
  };

  return (
    <Modal
      size="xl"
      show={props.showUpdateModal}
      onHide={() => {
        props.setShowUpdateModal(false);
      }}
      aria-labelledby="example-modal-sizes-title-xs"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-xs">
          Update Recommendation Criteria List
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="form-group col-md-3">
            <label className="float-left">
              {label.PostCriteria}
              <span className="errorText">*</span>
            </label>
            <Select
              isMulti
              name="selectedPostCriteria"
              ref={register({ required: true })}
              value={selectedPostCriteria}
              onChange={(selectedOptions) => {
                handlePostCriteria(selectedOptions);
              }}
              options={postCriteriaOptions && postCriteriaOptions}
            />

            {_.get("selectedPostCriteria.type", errors) === "required" && (
              <p className="errorText float-left">
                {clabel.MANDATORY_FIELD_MESSAGE}
              </p>
            )}
          </div>

          {data &&
            data.length > 0 &&
            data.map((item, index) => {
              const filteredValue =
                selectedPostCriteria &&
                selectedPostCriteria.filter(
                  (element) => element.value == item?.postCriteriaId
                );
              return (
                <>
                  <div className="table table-bordered m-3 p-2 mb-5">
                    <label className="post_criteria bold-text mb-2">
                      Post Criteria:{filteredValue[0]?.label}
                    </label>
                    <div className="row" key={index}>
                      <div className="col">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Category</th>
                              <th>SubCategory</th>
                              <th>Reserved Seats</th>
                              <th className="text-center">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.criteria.length > 0 &&
                              item.criteria.map((criteria, criteriaIndex) => (
                                <tr key={index}>
                                  {editCategory &&
                                  id == criteriaIndex &&
                                  index === indexrow ? (
                                    <td className="col-md-3">
                                      <label className="float-left">
                                        {label.SelectCategory}
                                        <span className="errorText">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        name={`selectedCategory[${index}]`}
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                          onCategoryChange(
                                            filteredValue[0].value,
                                            e.target.value,
                                            criteriaIndex
                                          );
                                        }}
                                        // value={selectedCategory}
                                      >
                                        <option key={0} value="">
                                          {clabel.COMBO_SELECT}
                                        </option>
                                        {adminCategoriesList &&
                                          adminCategoriesList.length > 0 &&
                                          adminCategoriesList.map(
                                            (element, index1) => (
                                              <option
                                                key={index1}
                                                value={element.name}
                                              >
                                                {element.name}
                                              </option>
                                            )
                                          )}
                                      </select>
                                    </td>
                                  ) : (
                                    <td>{criteria.category}</td>
                                  )}
                                  {editCategory &&
                                  id == criteriaIndex &&
                                  index === indexrow ? (
                                    <td className="col-md-3">
                                      <label className="float-left">
                                        {label.SelectSubCategory}
                                        <span className="errorText">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        name={`selectedSubCategory[${index}]`}
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                          onSubCategoryChange(
                                            filteredValue[0].value,
                                            e.target.value,
                                            criteriaIndex
                                          );
                                        }}
                                        // value={selectedCategory}
                                      >
                                        <option key={0} value="">
                                          {clabel.COMBO_SELECT}
                                        </option>
                                        {adminSubCategoriesList &&
                                          adminSubCategoriesList.length > 0 &&
                                          adminSubCategoriesList.map(
                                            (element, index1) => (
                                              <option
                                                key={index1}
                                                value={element.name}
                                              >
                                                {element.name}
                                              </option>
                                            )
                                          )}
                                      </select>
                                    </td>
                                  ) : (
                                    <td>{criteria.subCategory}</td>
                                  )}
                                  {editCategory &&
                                  id == criteriaIndex &&
                                  index === indexrow ? (
                                    <td className="col-md-3">
                                      <label className="float-left">
                                        {label.reservedSeat}
                                        <span className="errorText">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        pattern="^([0-9]|[1-9][0-9]{0,2}|1000)$"
                                        name={`reservedSeat[${index}]`}
                                        className="form-control"
                                        onChange={(e) => {
                                          onReserveSeatChange(
                                            filteredValue[0].value,
                                            e.target.value,
                                            criteriaIndex
                                          );
                                        }}
                                      />
                                    </td>
                                  ) : (
                                    <td>{criteria.reservedSeats}</td>
                                  )}

                                  <td className="text-center col-md-1">
                                    <i
                                      role="button"
                                      data-toggle="tooltip"
                                      title="Edit"
                                      className={
                                        "text-primary fa fa-edit fa-lg "
                                      }
                                      onClick={() =>
                                        editUser(
                                          criteria,
                                          "category",
                                          criteriaIndex,
                                          index
                                        )
                                      }
                                    ></i>
                                    &nbsp;&nbsp;
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {item && item.experience && (
                      <div className="row">
                        <div className="col-md-3 mb-3 d-flex">
                          <input
                            type="checkbox"
                            id={`experienceCheckbox${index}`}
                            defaultChecked={
                              item.experience && item.experience.flgConsider
                            }
                            name={`experienceCheckbox[${index}]`}
                            onChange={(event) =>
                              onhandleexperiencecheckbox(
                                filteredValue[0]?.value,
                                event.target.checked,
                                index
                              )
                            }
                          />
                          <label className="float-left ml-1">
                            {label.Experience}
                            <span className="errorText">*</span>
                          </label>
                        </div>
                      </div>
                    )}

                    {item.experience &&
                      item.experience.data &&
                      item.experience.data.length > 0 && (
                        <div className="row">
                          <div className="col">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Designation</th>
                                  <th>Job Nature</th>
                                  <th>Appointment Nature</th>
                                  <th className="text-center col-md-1">
                                    Actions
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.experience.data.length > 0 &&
                                  item.experience.data.map(
                                    (criteria, criteriaIndex) => {
                                      const designation = getDesignation.filter(
                                        (ite) => criteria.designation == ite.id
                                      );
                                      const Job = getjobnature.filter(
                                        (ite) =>
                                          criteria.jobNatureLookupId == ite.id
                                      );
                                      const appointment =
                                        getappointmentNature.filter(
                                          (ite) =>
                                            criteria.typeEmploymentLookupId ==
                                            ite.id
                                        );
                                      return (
                                        <tr key={criteriaIndex}>
                                          {editexperience &&
                                          id == criteriaIndex &&
                                          index === indexexperience ? (
                                            <td>
                                              <label className="float-left">
                                                {label.Designation}
                                                <span className="errorText">
                                                  *
                                                </span>
                                              </label>
                                              <select
                                                className="form-control"
                                                name={`Destination[${index}]`}
                                                ref={register({
                                                  required: true,
                                                })}
                                                onChange={(e) => {
                                                  onDesignation(
                                                    filteredValue[0]?.value,
                                                    e.target.value,
                                                    criteriaIndex
                                                  );
                                                }}
                                                // value={selectedCategory}
                                              >
                                                <option key={0} value="">
                                                  {clabel.COMBO_SELECT}
                                                </option>
                                                {getDesignation &&
                                                  getDesignation.length > 0 &&
                                                  getDesignation.map(
                                                    (element, index) => (
                                                      <option
                                                        key={index}
                                                        value={element.id}
                                                      >
                                                        {element.label}
                                                      </option>
                                                    )
                                                  )}
                                              </select>
                                            </td>
                                          ) : (
                                            <td>{designation[0]?.label}</td>
                                          )}

                                          {editexperience &&
                                          id == criteriaIndex &&
                                          index === indexexperience ? (
                                            <td>
                                              <label className="float-left">
                                                {label.Jobnature}
                                                <span className="errorText">
                                                  *
                                                </span>
                                              </label>
                                              <select
                                                className="form-control"
                                                name={`Jobnature[${index}]`}
                                                ref={register({
                                                  required: true,
                                                })}
                                                onChange={(e) => {
                                                  onJobNature(
                                                    filteredValue[0]?.value,
                                                    e.target.value,
                                                    criteriaIndex
                                                  );
                                                }}
                                                // value={selectedCategory}
                                              >
                                                <option key={0} value="">
                                                  {clabel.COMBO_SELECT}
                                                </option>
                                                {getjobnature &&
                                                  getjobnature.length > 0 &&
                                                  getjobnature.map(
                                                    (element, index) => (
                                                      <option
                                                        key={index}
                                                        value={element.id}
                                                      >
                                                        {element.label}
                                                      </option>
                                                    )
                                                  )}
                                              </select>
                                            </td>
                                          ) : (
                                            <td>{Job[0]?.label}</td>
                                          )}
                                          {editexperience &&
                                          id == criteriaIndex &&
                                          index === indexexperience ? (
                                            <td>
                                              <label className="float-left">
                                                {label.Appointmentnature}
                                                <span className="errorText">
                                                  *
                                                </span>
                                              </label>
                                              <select
                                                className="form-control"
                                                name={`Appointmentnature[${index}]`}
                                                ref={register({
                                                  required: true,
                                                })}
                                                onChange={(e) => {
                                                  onAppointmentNature(
                                                    filteredValue[0]?.value,
                                                    e.target.value,
                                                    criteriaIndex
                                                  );
                                                }}
                                                // value={selectedCategory}
                                              >
                                                <option key={0} value="">
                                                  {clabel.COMBO_SELECT}
                                                </option>
                                                {getappointmentNature &&
                                                  getappointmentNature.length >
                                                    0 &&
                                                  getappointmentNature.map(
                                                    (element, index) => (
                                                      <option
                                                        key={index}
                                                        value={element.id}
                                                      >
                                                        {element.label}
                                                      </option>
                                                    )
                                                  )}
                                              </select>
                                            </td>
                                          ) : (
                                            <td>{appointment[0]?.label}</td>
                                          )}

                                          <td className="text-center">
                                            <i
                                              role="button"
                                              data-toggle="tooltip"
                                              title="Edit"
                                              className={
                                                "text-primary fa fa-edit fa-lg"
                                              }
                                              onClick={() =>
                                                editUser(
                                                  criteria,
                                                  "experience",
                                                  criteriaIndex,
                                                  index
                                                )
                                              }
                                            ></i>
                                            &nbsp;&nbsp;
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    {item && item.qualification && (
                      <div className="row">
                        <div className="col-md-3 mt-3 mb-3">
                          <input
                            type="checkbox"
                            id={`qualificationCheckbox${index}`}
                            name={`qualificationCheckbox[${index}]`}
                            defaultChecked={
                              item.qualification &&
                              item.qualification.flgConsider
                            }
                            onChange={(event) =>
                              onhandlequalificationcheckbox(
                                filteredValue[0]?.value,
                                event.target.checked,
                                index
                              )
                            }
                          />
                          <label className="float-left ml-1">
                            {label.Qualification}
                            <span className="errorText">*</span>
                          </label>
                        </div>
                      </div>
                    )}

                    {item.qualification &&
                      item.qualification.data &&
                      item.qualification.data.length > 0 && (
                        <div className="row new">
                          <div className="col">
                            <table className="table test">
                              <thead>
                                <tr>
                                  <th>Qualification Type</th>
                                  <th>Qualification Name</th>
                                  <th className="text-center col-md-1">
                                    Actions
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.qualification.data &&
                                  item.qualification.data.length > 0 &&
                                  item.qualification.data.map(
                                    (criteria, criteriaIndex) => (
                                      <tr key={criteriaIndex}>
                                        {editqualification &&
                                        id == criteriaIndex &&
                                        index === indexqualification ? (
                                          <td className="col-md-3">
                                            <label className="float-left">
                                              {label.QualificationType}
                                              <span className="errorText">
                                                *
                                              </span>
                                            </label>
                                            <select
                                              className="form-control"
                                              name={`qualificationType[${index}]`}
                                              ref={register({
                                                required: true,
                                              })}
                                              onChange={(e) => {
                                                onQualificationType(
                                                  filteredValue[0]?.value,
                                                  e.target.value,
                                                  criteriaIndex
                                                );
                                              }}
                                            >
                                              <option key={0} value="">
                                                {clabel.COMBO_SELECT}
                                              </option>
                                              {getqualificationtype &&
                                                getqualificationtype.length >
                                                  0 &&
                                                getqualificationtype.map(
                                                  (element, index) => (
                                                    <option
                                                      key={index}
                                                      value={
                                                        element.qualificationTypeCode
                                                      }
                                                    >
                                                      {
                                                        element.qualificationTypeCode
                                                      }
                                                    </option>
                                                  )
                                                )}
                                            </select>
                                          </td>
                                        ) : (
                                          <td>
                                            {criteria.qualificationtypecode}
                                          </td>
                                        )}
                                        {editqualification &&
                                        id == criteriaIndex &&
                                        index === indexqualification ? (
                                          <td className="col-md-3">
                                            <label className="float-left">
                                              {label.QualificationName}
                                              <span className="errorText">
                                                *
                                              </span>
                                            </label>
                                            <select
                                              className="form-control"
                                              name={`qualifcationName[${index}]`}
                                              ref={register({
                                                required: true,
                                              })}
                                              onChange={(e) => {
                                                onQualificationName(
                                                  filteredValue[0]?.value,
                                                  e.target.value,
                                                  criteriaIndex
                                                );
                                              }}
                                            >
                                              <option key={0} value="">
                                                {clabel.COMBO_SELECT}
                                              </option>
                                              {getqualificationName &&
                                                getqualificationName.length >
                                                  0 &&
                                                getqualificationName.map(
                                                  (element, index) => (
                                                    <option
                                                      key={index}
                                                      value={
                                                        element.qualificationNameCode
                                                      }
                                                    >
                                                      {
                                                        element.qualificationNameCode
                                                      }
                                                    </option>
                                                  )
                                                )}
                                            </select>
                                          </td>
                                        ) : (
                                          <td>
                                            {criteria.qualificationnamecode}
                                          </td>
                                        )}

                                        <td className="text-center">
                                          <i
                                            role="button"
                                            data-toggle="tooltip"
                                            title="Edit"
                                            className={
                                              "text-primary fa fa-edit fa-lg"
                                            }
                                            onClick={() =>
                                              editUser(
                                                criteria,
                                                "qualification",
                                                criteriaIndex,
                                                index
                                              )
                                            }
                                          ></i>
                                          &nbsp;&nbsp;
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    {item && item.dob && (
                      <div className="row">
                        <div className="col-md-3 mt-3 mb-3">
                          <input
                            type="checkbox"
                            id={`dobCheckbox_${index}`}
                            name={`dobCheckbox[${index}]`}
                            defaultChecked={item.dob && item.dob.flgConsider} // Check if item.dob is defined before accessing flgConsider
                            onChange={(event) =>
                              onhandledobcheckbox(
                                filteredValue[0]?.value,
                                event.target.checked,
                                index
                              )
                            }
                          />
                          <label className="float-left ml-1">
                            {label.DOB}
                            <span className="errorText">*</span>
                          </label>
                        </div>
                      </div>
                    )}

                    {item.dob && (
                      <div className="row" key={index}>
                        <div className="col">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Order</th>
                                <th className="text-center col-md-1">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                {editdob && index === indexdob ? (
                                  <td>
                                    <div className="col-md-3">
                                      <label className="float-left">
                                        {label.SelectOrder}
                                        <span className="errorText">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        name={`selectedorder[${index}]`}
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                          ondobOrder(
                                            filteredValue[0]?.value,
                                            e.target.value,
                                            index
                                          );
                                        }}
                                        // value={selectedCategory}
                                      >
                                        <option key={0} value="">
                                          {clabel.COMBO_SELECT}
                                        </option>
                                        {dobcheckedistrue &&
                                          dobcheckedistrue.length > 0 &&
                                          dobcheckedistrue.map(
                                            (element, index) => (
                                              <option
                                                key={index}
                                                value={element.name}
                                              >
                                                {element.name}
                                              </option>
                                            )
                                          )}
                                      </select>
                                      {/* {_.get(
                               "selectedorder.type",
                               errors
                             ) === "required" && (
                               <p className="errorText float-left">
                                 {clabel.MANDATORY_FIELD_MESSAGE}
                               </p>
                             )} */}
                                    </div>
                                  </td>
                                ) : (
                                  <td>{item.dob.order}</td>
                                )}

                                <td className="text-center">
                                  <i
                                    role="button"
                                    data-toggle="tooltip"
                                    title="Edit"
                                    className={"text-primary fa fa-edit fa-lg"}
                                    onClick={() =>
                                      editUser(item.dob, "dob", id, index)
                                    }
                                  ></i>
                                  &nbsp;&nbsp;
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              );
            })}
        </div>
        <div className="row custom-button text-align-right">
          <button
            className="btn btn-secondary ml-auto mr-2"
            type="button"
            onClick={() => {
              props.setShowUpdateModal(false);
            }}
          >
            {label.CANCEL}
          </button>
          {props&& props.setUpdatedValue&&props.setUpdatedValue.length>0&&(<button
            className="btn btn-primary"
            onClick={() => {
              onSubmit();
            }}
          >
            {label.SAVE}
          </button>)}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateRecommendationCriteria;
